import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';
import MuiTypography from '@mui/material/Typography';

const Root = styled(MuiBox) `
  display: flex;
  flex-direction: row;
  width: 100%;
  ${({ theme }) => `
    padding: ${theme.spacing(1.75, 0, 0, 0)};
    color: ${theme.palette.N20.main};
  `}
  > * {
    flex: 1;
  }
`;
const ContentWrapper = styled(MuiBox) `
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;
const Label = styled(MuiTypography) `
  ${({ theme }) => `
    color: ${theme.palette.N30.main};
  `}
`;
const Value = styled(MuiTypography) `
  margin: ${({ theme }) => theme.spacing(0, 0, 0, 1)};
`;
const Property = (_a) => {
    var { label, value = '', children, className } = _a, rest = __rest(_a, ["label", "value", "children", "className"]);
    const content = useMemo(() => React__default.isValidElement(value) ? (value) : (jsx(Value, Object.assign({ variant: "body1", noWrap: true }, { children: value }))), [value]);
    return (jsxs(Root, Object.assign({ className: className }, rest, { children: [label && jsx(Label, Object.assign({ variant: "body1" }, { children: label })), jsxs(ContentWrapper, { children: [value && content, !value && children] })] })));
};

export { Property as default };
//# sourceMappingURL=Property.js.map
